import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../../home";
import { UserManagement } from "../../userManagement";
import { Notifications } from "../../notification";
import { StudentManagement } from "../../students/studentManagement";
import { StudentInvoices } from "../../students/studentInvoices";
import { SchoolManagement } from "../../schoolsManagement";
import { Settings } from "../../settings";
import { Transactions } from "../../transactions";
import { TransactionDetail } from "../../transactionDetail";
import { UserDetail } from "../../userDetail";
import { InvoiceDetail } from "../../students/invoiceDetail";
import PdfView from "../../transactionDetail/components/pdf";
import Print from "../../transactionDetail/components/Print";
import { SchoolDetail } from "../../schoolDetail";
import { BankDetail } from "../../bankDetail";
import { BankManagement } from "../../banksManagement";

export const DashboardRoutes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route
        path="/students"
        exact
        component={StudentManagement}
      />
      <Route
        path="/balances"
        exact
        component={StudentInvoices}
      />
      <Route
        path="/students/student-detail/:studentId"
        exact
        component={InvoiceDetail}
      />
      <Route
        path="/schools/schools-detail/:schoolId"
        exact
        component={SchoolDetail}
      />
      <Route path="/schools" exact component={SchoolManagement} />
      <Route path="/settings" exact component={Settings} />
      <Route
        path="/transactions"
        exact
        render={() => <Transactions status="APPROVED" />}
      />
      <Route
        path="/transactions/pending"
        exact
        render={() => <Transactions status="PENDING" />}
      />
      <Route
        path="/transactions/rejected"
        exact
        render={() => <Transactions status="REJECTED" />}
      />
      <Route
        path="/transactions/:transactionId"
        exact
        component={TransactionDetail}
      />
      <Route path="/users" exact component={UserManagement} />
      <Route path="/notification" exact component={Notifications} />
      <Route path="/users/:userId" exact component={UserDetail} />
      <Route path="/pdfDownload" exact component={PdfView} />
      <Route path="/printDownload" exact component={Print} />
      <Route path="/accounts" exact component={BankManagement} />
      <Route path="/accounts/accounts-detail/:accountId" exact component={BankDetail} />
    </Switch>
  );
};
